<!-- The page's wallpaper: one still moment of the hero's board, faint, behind everything. The board is the
     theme's own motif (HERO_MOTIFS: Aurora's northern lights, Sakura's cherry branch, Autumn's maple, Everest's blizzard, Sequoia's giant, Roraima's tepui, Salda's lake, Ocean's deep, Spring's meadow, Reynisfjara's black beach, Fuji's dawn, Etna's lava, Istanbul's bridge, Miami's sunset, Rio's Copacabana, Paris's Eiffel Tower, Tallinn's winter old town, Tokyo's tower at night, Sydney's harbour, Prague's river at blue hour, Madrid's Gran Vía, Vienna's opera house, Dublin's Malahide Castle, London's Big Ben in the rain), the circuit board for every other theme. -->
<ng-container [ngSwitch]="heroMotif">
  <app-hero-aurora *ngSwitchCase="'aurora'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-aurora>
  <app-hero-sakura *ngSwitchCase="'sakura'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-sakura>
  <app-hero-autumn *ngSwitchCase="'autumn'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-autumn>
  <app-hero-everest *ngSwitchCase="'everest'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-everest>
  <app-hero-sequoia *ngSwitchCase="'sequoia'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-sequoia>
  <app-hero-roraima *ngSwitchCase="'roraima'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-roraima>
  <app-hero-salda *ngSwitchCase="'salda'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-salda>
  <app-hero-ocean *ngSwitchCase="'ocean'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-ocean>
  <app-hero-spring *ngSwitchCase="'spring'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-spring>
  <app-hero-reynisfjara *ngSwitchCase="'reynisfjara'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-reynisfjara>
  <app-hero-fuji *ngSwitchCase="'fuji'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-fuji>
  <app-hero-etna *ngSwitchCase="'etna'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-etna>
  <app-hero-istanbul *ngSwitchCase="'istanbul'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-istanbul>
  <app-hero-miami *ngSwitchCase="'miami'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-miami>
  <app-hero-rio-de-janeiro *ngSwitchCase="'rio'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-rio-de-janeiro>
  <app-hero-paris *ngSwitchCase="'paris'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-paris>
  <app-hero-tallinn *ngSwitchCase="'tallinn'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-tallinn>
  <app-hero-tokyo *ngSwitchCase="'tokyo'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-tokyo>
  <app-hero-sydney *ngSwitchCase="'sydney'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-sydney>
  <app-hero-prague *ngSwitchCase="'prague'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-prague>
  <app-hero-madrid *ngSwitchCase="'madrid'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-madrid>
  <app-hero-vienna *ngSwitchCase="'vienna'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-vienna>
  <app-hero-dublin *ngSwitchCase="'dublin'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-dublin>
  <app-hero-london *ngSwitchCase="'london'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-london>
  <app-hero-bioluminescence *ngSwitchCase="'bioluminescence'" class="hero-wallpaper" [frozen]="true" [palette]="heroPalette"></app-hero-bioluminescence>
  <app-hero-circuit *ngSwitchDefault class="hero-wallpaper" [frozen]="true" [clearing]="false"></app-hero-circuit>
</ng-container>

<div class="hero" id="head">
  <!-- The stage: the circuit board awake under the pointer, the content over it. -->
  <div class="hero-stage" #heroStage>
    <!-- the logo, the motto and the counter are parts of the circuit (owner, 2026-10-10): the board
         ends its runs at their edges and strikes them, never runs under them -->
    <ng-container [ngSwitch]="heroMotif">
      <app-hero-aurora *ngSwitchCase="'aurora'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                       [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-aurora>
      <app-hero-sakura *ngSwitchCase="'sakura'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                       [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-sakura>
      <app-hero-autumn *ngSwitchCase="'autumn'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                       [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-autumn>
      <app-hero-everest *ngSwitchCase="'everest'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                        [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-everest>
      <app-hero-sequoia *ngSwitchCase="'sequoia'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                        [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-sequoia>
      <app-hero-roraima *ngSwitchCase="'roraima'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                        [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-roraima>
      <app-hero-salda *ngSwitchCase="'salda'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                      [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-salda>
      <app-hero-ocean *ngSwitchCase="'ocean'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                      [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-ocean>
      <app-hero-spring *ngSwitchCase="'spring'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                       [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-spring>
      <app-hero-reynisfjara *ngSwitchCase="'reynisfjara'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                            [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-reynisfjara>
      <app-hero-fuji *ngSwitchCase="'fuji'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                     [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-fuji>
      <app-hero-etna *ngSwitchCase="'etna'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                     [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-etna>
      <app-hero-istanbul *ngSwitchCase="'istanbul'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                         [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-istanbul>
      <app-hero-miami *ngSwitchCase="'miami'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                      [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-miami>
      <app-hero-rio-de-janeiro *ngSwitchCase="'rio'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                      [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-rio-de-janeiro>
      <app-hero-paris *ngSwitchCase="'paris'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                      [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-paris>
      <app-hero-tallinn *ngSwitchCase="'tallinn'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                      [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-tallinn>
      <app-hero-tokyo *ngSwitchCase="'tokyo'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                      [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-tokyo>
      <app-hero-sydney *ngSwitchCase="'sydney'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                      [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-sydney>
      <app-hero-prague *ngSwitchCase="'prague'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                      [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-prague>
      <app-hero-madrid *ngSwitchCase="'madrid'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                      [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-madrid>
      <app-hero-vienna *ngSwitchCase="'vienna'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                      [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-vienna>
      <app-hero-dublin *ngSwitchCase="'dublin'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                      [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-dublin>
      <app-hero-london *ngSwitchCase="'london'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                      [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-london>
      <app-hero-bioluminescence *ngSwitchCase="'bioluminescence'" #circuit class="hero-board" [stage]="heroStage" [palette]="heroPalette"
                      [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"></app-hero-bioluminescence>
      <app-hero-circuit *ngSwitchDefault #circuit class="hero-board" [clearing]="false" [stage]="heroStage"
                        [solids]="[ heroLogoBox, heroMottoEl, heroCounterEl ]"
                        [solidRoom]="[ { x: 10, y: 20 }, null, null ]"></app-hero-circuit>
    </ng-container>
  <div class="hero-content">
    <!-- the page's one h1, for screen readers and search engines (the logo says it to the eye); the
         banner that carried an h1 left the home with the themes box (2026-10-10) -->
    <h1 class="sr-only">Codigrate: Themes &amp; Color Tools for Modern Developers</h1>
    <div class="inline-logo-wrapper" #heroLogoBox>
      <img class="inline-logo"
           [src]="heroLogo"
           fetchpriority="high"
           alt="Codigrate logo - themes and color tools for JetBrains, Xcode, VS Code, Cursor, Antigravity, Zed, Chrome, Firefox, Slack and Ghostty"/>
    </div>
    <p #heroMottoEl>
      {{ BRAND.bio }}
    </p>

    <!-- Downloads -->
    <div class="section-header front" #heroCounterEl>
      <h3 class="section-description">
        Trusted by users worldwide
        <br/>
        <span class="counter-glass"><span class="stress-line">
          <!-- an invisible digit while the loader shows, so the line keeps the number's metrics
               and nothing moves when the count starts (owner, 2026-10-10) -->
          <span class="counter-ghost" *ngIf="!pluginDownloadsLoaded" aria-hidden="true">0</span>
          <span class="counter-loader-container" *ngIf="!pluginDownloadsLoaded">
            <span class="counter-loader-left"></span>
            <span class="counter-loader-right"></span>
            <span class="counter-loader-dots">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </span>
            <span class="counter-loader-warp-left"></span>
            <span class="counter-loader-warp-right"></span>
          </span>
          <ng-container *ngIf="pluginDownloadsLoaded">{{ animatedDownloads }}</ng-container>
        </span>
        {{ ' downloads' }}
        </span>
      </h3>
    </div>
  </div>

  </div>
<!-- The developer programs we are a member of: a strip as wide as the stage on the input colour,
     "Member Of", a hairline and the two programs, Google then GitHub (owner, 2026-10-10); each
     links to the profile. -->
  <div class="hero-badges">
    <span class="hb-lead">Member Of</span>
    <span class="hb-divider" aria-hidden="true"></span>
    <a class="hb-card" [href]="environmentCommon.website.googleDeveloper.url + '/' + environmentCommon.company.social.googleDeveloper" target="_blank" rel="noopener">
      <span class="hb-tile hb-tile-google"><svg class="hero-badge-mark hero-badge-mark-google" viewBox="-3 0 262 262" aria-hidden="true">
        <path d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027" fill="#4285F4"/>
        <path d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1" fill="#34A853"/>
        <path d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782" fill="#FBBC05"/>
        <path d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251" fill="#EB4335"/>
      </svg></span>
      <span class="hb-text"><span class="hb-name">Google</span><span class="hb-sub">Developer Program</span></span>
    </a>
    <a class="hb-card" [href]="environmentCommon.website.github.url + '/' + environmentCommon.company.social.github" target="_blank" rel="noopener">
      <span class="hb-tile hb-tile-github"><svg class="hero-badge-mark" viewBox="0 0 92.3 90" aria-hidden="true">
        <path d="M46.1,0C20.6,0,0,20.6,0,46.1c0,20.4,13.2,37.7,31.5,43.8c2.3,0.4,3.2-1,3.2-2.2c0-1.1-0.1-4.7-0.1-8.6
              c-11.6,2.1-14.6-2.8-15.5-5.4c-0.5-1.3-2.8-5.4-4.7-6.5c-1.6-0.9-3.9-3-0.1-3.1c3.6-0.1,6.2,3.3,7.1,4.7c4.2,7,10.8,5,13.4,3.8
              c0.4-3,1.6-5,2.9-6.2c-10.3-1.2-21-5.1-21-22.8c0-5,1.8-9.2,4.7-12.4c-0.5-1.2-2.1-5.9,0.5-12.2c0,0,3.9-1.2,12.7,4.7
              c3.7-1,7.6-1.6,11.5-1.6c3.9,0,7.8,0.5,11.5,1.6c8.8-6,12.7-4.7,12.7-4.7c2.5,6.3,0.9,11.1,0.5,12.2c2.9,3.2,4.7,7.3,4.7,12.4
              c0,17.7-10.8,21.6-21.1,22.8c1.7,1.4,3.1,4.2,3.1,8.5c0,6.2-0.1,11.1-0.1,12.7c0,1.2,0.9,2.7,3.2,2.2c18.2-6.1,31.4-23.4,31.4-43.8
              C92.3,20.6,71.6,0,46.1,0z"/>
      </svg></span>
      <span class="hb-text"><span class="hb-name">GitHub</span><span class="hb-sub">Developer Program</span></span>
    </a>
  </div>
</div>

<!-- Dock Town under the hero (owner, 2026-10-10): the app's big window town by town -->
<app-product-showcase class="home-dock-town" [config]="dockTownShowcase"></app-product-showcase>
<app-product-showcase class="home-tidy-desktop" [config]="tidyDesktopShowcase"></app-product-showcase>
<!-- LangMi under Tidy Desktop (owner 2026-10-22; AI Token Meter moved under the Color Pickers 2026-10-28) -->
<app-product-showcase class="home-langmi" [config]="langmiShowcase"></app-product-showcase>
<!-- The themes box (owner 2026-10-10, trial on the home-themes-box branch): one panel, one theme at a
     time, every theme as an icon under it; it replaces the themes strip and the rotating banner. The
     home keeps the state it had for the banner (theme, platform, store button, rotation). -->
<app-theme-showcase class="home-themes-box"
                    [themes]="PLUGIN_SCREENSHOTS"
                    [active]="selectedScreenshot"
                    [platforms]="visiblePlatforms"
                    [platformIndex]="selectedPlatformIndex"
                    [screenshot]="displayedPlatformScreenshot"
                    [ctaText]="ctaText"
                    [ctaLabels]="ctaLabels"
                    [planned]="selectedPlatformPlanned"
                    [priceLabel]="selectedPriceLabel || ''"
                    [downloads]="selectedScreenshot?.product?.totalDownloads > 0 ? selectedScreenshot.product.downloads : ''"
                    [statsLoaded]="pluginDownloadsLoaded"
                    [rating]="selectedScreenshot?.product?.rating"
                    [siteDark]="darkModeActive"
                    (hold)="holdThemeBox( $event )"
                    (themePick)="pickTheme( $event )"
                    (platformPick)="selectPlatform( $event )"
                    (cta)="tryNowSelected()">
  <!-- the reviews at the foot of the themes box (owner 2026-10-11, trial on home-reviews-box), in
       place of the full-bleed wall that sat over the coverage matrix -->
  <app-review-showcase tsxReviews *ngIf="!reviewsLoaded || HOME_REVIEWS.length"
                       [reviews]="HOME_REVIEWS" [loaded]="reviewsLoaded"
                       [themes]="totalThemesCount"
                       [platforms]="uniquePlatformCount"
                       [downloads]="actualDownloadsTotal > 0 ? utilService.numberFormatter( actualDownloadsTotal ) : ''"></app-review-showcase>
</app-theme-showcase>

<!-- Color Pickers (owner 2026-10-10): the color picker of every platform in one card, the platform
     switched with the chips (color-pickers.data.ts), as wide as the showcases above it and over the
     themes; the macOS Apps, iOS Apps, Chrome Extensions and JetBrains Plugins lists are gone. -->
<app-product-showcase class="home-color-pickers" [config]="colorPickersShowcase"></app-product-showcase>
<!-- AI Token Meter under the Color Pickers (owner 2026-10-28, once it was sold on the site only) -->
<app-product-showcase class="home-ai-token-meter" [config]="aiTokenMeterShowcase"></app-product-showcase>

<!-- Web Tools (owner 2026-10-11): the free in-browser tools in one box like the ones above, one tool at a
     time, switched with the chips; every tool stays rendered so it keeps its colours when you come back
     to it (tools-showcase.component.ts) -->
<app-tools-showcase class="home-web-tools" [slides]="webToolSlides" [active]="webTool"
                    (pick)="pickWebTool( $event )" (cta)="onWebToolCta( $event )">
  <!-- the AI Cost Calculator's own card (2026-10-19), the box's first tool; its button opens the full tool on the
       numbers picked here -->
  <div class="tls-pane" [class.on]="webTool === 'ai-cost'">
    <app-ai-cost-widget [values]="aiCost.values" [scenarioKey]="aiCost.scenarioKey" [modelId]="aiCost.modelId"
                        (cardChange)="onAiCostCard( $event )"></app-ai-cost-widget>
  </div>
  <!-- AI Price Watch's board (2026-10-28), the box's second tool; its button opens the full board on what is picked here -->
  <div class="tls-pane" [class.on]="webTool === 'ai-watch'">
    <app-ai-price-watch-widget class="home-ai-watch" [compact]="true" [model]="aiWatch.model" [field]="aiWatch.field" [range]="aiWatch.range"
                               (boardChange)="onAiWatchBoard( $event )"></app-ai-price-watch-widget>
  </div>
  <div class="tls-pane" [class.on]="webTool === 'color'">
    <app-color-widget (colorChange)="webToolColor = $event"></app-color-widget>
  </div>
  <div class="tls-pane" [class.on]="webTool === 'palette'">
    <app-palette-widget
      [studio]="true"
      [palette]="paletteColors"
      [subtitle]="paletteSubtitle"
      [scheme]="paletteGenerator"
      [count]="paletteCount"
      (countChange)="paletteCount = $event"
      [showDetailsCta]="false"
      (editColor)="onPaletteEdit( $event )"
      (reorder)="onPaletteReorder( $event )"
      (reverse)="onPaletteReverse()"
      (addColor)="onPaletteAdd()"
      (removeColor)="onPaletteRemove( $event )"
      (generate)="onPaletteGenerate( $event )"
      (uploadImage)="onPaletteUpload( $event )">
    </app-palette-widget>
  </div>
  <div class="tls-pane" [class.on]="webTool === 'gradient'">
    <app-gradient-widget
      [palette]="gradientColors"
      [subtitle]="gradientSubtitle"
      [scheme]="gradientGenerator"
      [type]="gradientType"
      [angle]="gradientAngle"
      [count]="gradientCount"
      (countChange)="gradientCount = $event"
      [positions]="gradientPositions"
      (positionChange)="onGradientPosition( $event )"
      [showDetailsCta]="false"
      (editColor)="onGradientEdit( $event )"
      (removeColor)="onGradientRemove( $event )"
      (reverse)="onGradientReverse()"
      (generate)="onGradientGenerate( $event )"
      (uploadImage)="onGradientUpload( $event )"
      (typeChange)="gradientType = $event"
      (angleChange)="gradientAngle = $event"
      (insertStop)="onGradientInsertStop( $event )">
    </app-gradient-widget>
  </div>
  <div class="tls-pane" [class.on]="webTool === 'wallpaper'">
    <app-wallpaper-widget
      [palette]="wallpaperColors"
      [subtitle]="wallpaperSubtitle"
      [scheme]="wallpaperGenerator"
      [count]="wallpaperCount"
      (countChange)="wallpaperCount = $event"
      [style]="wallpaperStyle"
      [sizeKey]="wallpaperSizeKey"
      [seed]="wallpaperSeed"
      [showDetailsCta]="false"
      (editColor)="onWallpaperEdit( $event )"
      (reorder)="onWallpaperReorder( $event )"
      (reverse)="onWallpaperReverse()"
      (addColor)="onWallpaperAdd()"
      (removeColor)="onWallpaperRemove( $event )"
      (generate)="onWallpaperGenerate( $event )"
      (uploadImage)="onWallpaperUpload( $event )"
      (styleChange)="onWallpaperStyle( $event )"
      [params]="wallpaperParams"
      (paramsChange)="onWallpaperParams( $event )">
    </app-wallpaper-widget>
  </div>
  <!-- the wallpaper box's palette, style and seed as a macOS dynamic wallpaper (2026-10-13) -->
  <div class="tls-pane" [class.on]="webTool === 'dynamic'">
    <app-wallpaper-widget
      cardTitle="Dynamic Wallpaper"
      [palette]="wallpaperColors"
      [subtitle]="wallpaperSubtitle"
      [scheme]="wallpaperGenerator"
      [count]="wallpaperCount"
      (countChange)="wallpaperCount = $event"
      [style]="wallpaperStyle"
      [seed]="wallpaperSeed"
      [showDetailsCta]="false"
      (editColor)="onWallpaperEdit( $event )"
      (reorder)="onWallpaperReorder( $event )"
      (reverse)="onWallpaperReverse()"
      (addColor)="onWallpaperAdd()"
      (removeColor)="onWallpaperRemove( $event )"
      (generate)="onWallpaperGenerate( $event )"
      (uploadImage)="onWallpaperUpload( $event )"
      (styleChange)="onWallpaperStyle( $event )"
      [params]="wallpaperParams"
      (paramsChange)="onWallpaperParams( $event )"
      [previewImage]="dynamicDayUrl"
      [previewLoading]="dynamicLoading"
      [dynamic]="dynamicSettings"
      [dynamicModes]="DYNAMIC_MODES"
      [frameCounts]="FRAME_COUNTS"
      (dynamicChange)="onDynamicChange( $event )">
    </app-wallpaper-widget>
  </div>
  <!-- the contrast checker's own card (2026-10-15); its button opens the full tool on the pair picked here -->
  <div class="tls-pane" [class.on]="webTool === 'contrast'">
    <app-contrast-widget [fg]="contrastFg" [bg]="contrastBg" (colorsChange)="onContrastColors( $event )"></app-contrast-widget>
  </div>
  <!-- the colour blindness simulator's own card (2026-10-15), on a random theme's IDE screenshot -->
  <div class="tls-pane" [class.on]="webTool === 'cvd'">
    <app-cvd-widget [src]="cvdStart"></app-cvd-widget>
  </div>
  <!-- the code snippet image generator's own card (2026-10-13); its badge and its button open the full tool on
       the theme and the language picked here -->
  <div class="tls-pane" [class.on]="webTool === 'code'">
    <app-code-image-widget source="home" (stateChange)="codeSnippetState = $event" (previewClick)="openCodeSnippet()"></app-code-image-widget>
  </div>
  <div class="tls-pane" [class.on]="webTool === 'converters'">
    <!-- every converter, the list drifting up (twice over, so the loop is seamless); the pointer holds it -->
    <div class="home-converters">
      <div class="home-converters-track" appDrift="70">
        <div class="converter-tools" *ngFor="let copy of [ 0, 1 ]" [attr.aria-hidden]="copy === 1 ? 'true' : null">
          <!-- the tools page's cards (owner 2026-10-12): the icon large, the name, two lines on the formats -->
          <a *ngFor="let tool of CONVERTER_TOOLS" [routerLink]="tool.url" class="tl-card" [attr.tabindex]="copy === 1 ? -1 : null">
            <span class="tl-cover">
              <img [src]="tool.logo" alt="" width="88" height="88" loading="lazy" decoding="async">
            </span>
            <span class="tl-name">{{ tool.name }}</span>
            <span class="tl-desc">{{ toolLine( tool ) }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</app-tools-showcase>

<!-- Color Palettes (owner 2026-10-11): one box like the themes box, one palette at a time, the apps it comes
     for as logos and every palette as its theme's icon (palette-showcase.component.ts) -->
<app-palette-showcase class="home-palettes-box" [siteDark]="darkModeActive"></app-palette-showcase>

<!-- From the Blog (owner 2026-10-11): one box like the others, one post at a time, the latest posts in its
     dock (blog-showcase.component.ts) -->
<app-blog-showcase class="home-blog-box" *ngIf="LATEST_POSTS.length" [posts]="LATEST_POSTS"></app-blog-showcase>

<!-- Our Services (owner 2026-10-11): one box like the apps', one service at a time, switched with the chips
     (services-showcase.data.ts) -->
<!-- one anchor a service, where the footer's service links land (#services-<key>, product.service productUrl);
     the box then shows that service (onServiceFragment) -->
<div class="svc-anchors" aria-hidden="true">
  <span *ngFor="let s of servicesShowcase.slides" [id]="SERVICES[ 0 ].key + '-' + s.key"></span>
</div>
<app-product-showcase #servicesBox class="home-services-box" [config]="servicesShowcase">
  <!-- the references at the foot of the box (owner 2026-10-11: as the reviews sit in the themes box), in place
       of the References section that followed it -->
  <div dtsFoot class="svc-refs">
    <!-- the themes box's reviews head (owner 2026-10-11): the title with, in place of the average and its stars,
         the companies' logos and who they are; the way to them all under it -->
    <div class="svc-refs-head">
      <div class="svc-refs-line">
        <h3 class="svc-refs-title">What Our Customers Say</h3>
        <span class="svc-refs-trust">
          <span class="svc-refs-logos" aria-hidden="true">
            <img *ngFor="let r of REFERENCE_REVIEWS" [src]="r.themeLogo" alt="" width="26" height="26" loading="lazy" decoding="async"/>
          </span>
          <span class="svc-refs-trust-text">Trusted by Top Tech Companies</span>
        </span>
      </div>
    </div>
    <div class="svc-refs-grid">
      <app-review-card *ngFor="let r of REFERENCE_REVIEWS" [review]="r"></app-review-card>
    </div>
  </div>
</app-product-showcase>
